module.exports = __webpack_public_path__ + "media/assets/images/synchronize_start_gray-33c84bc235bb2586fe5a554235073d57.png";